module.exports = __webpack_public_path__ + "static/UX Lead & UX Manager_Annie Yining Wang-95a476d392f854aa80299fc46ffe0c9a.pdf";